import type { V10ControlRoomSection, V10ProjectMode } from "./v10-phase-model.js";
import type { V10IntakeFocus, V10RoutePatch, V10SheetId } from "../routing/v10-routing.js";
import type { V10View } from "../routing/v10-views.js";

export function v10ProjectRoute(input: {
  readonly projectId: string;
  readonly section?: V10ControlRoomSection | null;
  readonly mode?: V10ProjectMode;
}): V10RoutePatch {
  return {
    view: "project",
    projectId: input.projectId,
    ...(input.section !== undefined ? { section: input.section } : {}),
    sheet: null,
    ...(input.mode ? { mode: input.mode } : {}),
  };
}

export function v10ViewRoute(view: V10View, intake?: V10IntakeFocus): V10RoutePatch {
  return { view, sheet: null, intake: intake ?? null };
}

export function v10NewWorkSheet(mode?: V10ProjectMode): V10RoutePatch {
  return {
    sheet: "new-work" satisfies V10SheetId,
    ...(mode ? { mode } : {}),
  };
}

export function v10CloseSheet(): V10RoutePatch {
  return { sheet: null };
}

export const V10_FORBIDDEN_VIEWS = [
  "more",
  "new",
  "salesroom",
  "proof",
  "handoff",
  "l2",
  "deploy",
  "command",
] as const;
